import Form from 'Components/Forms/FormGenerator';
import FormViewer from 'Components/FormViewer';
import { actions } from 'ducks/buildings';
import React from 'react';
import { connect } from 'react-redux';
import { serializeForm } from 'utils/forms/utils';
import validators from 'utils/forms/validators';

const Component = props => {
    const { building, submitting } = props;
    const { closeDrawer, update } = props;

    const formSchema = [
        {
            label: 'Name\x2a',
            name: 'name',
            type: 'text',
            validate: [validators.required]
        },
        {
            label: 'Latitude\x2a',
            name: 'latitude',
            type: 'text',
            validate: [validators.required]
        },
        {
            label: 'Longitude\x2a',
            name: 'longitude',
            type: 'text',
            validate: [validators.required]
        }
    ];

    const onSubmit = values => update(
        building.id,
        serializeForm(values, formSchema, building),
        () => closeDrawer()
    );

    return (
        <FormViewer label="Edit Building">
            <Form
                formSchema={formSchema}
                formInitialValues={building}
                isSubmitting={submitting}
                onSubmit={onSubmit}
            />
        </FormViewer>
    );
};

const mapStateToProps = (state, ownProps) => ({
    building: state.buildings.models[ownProps.id],
    submitting: state.buildings.submitting
});

const mapDispatchToProps = ({
    update: actions.update
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
